import React from 'react';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-136" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-6xl" data-id="element-137" data-mp="3ggaqfufcyb4x">
        <p className="whitespace-nowrap font-serif text-3xl tracking-tight" data-id="element-138" data-mp="3ghc0pwojutll">
          音樂備課寶<span className="align-super text-[0.5em]" data-id="element-139" data-mp="32pp7k5pwm171">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-140" data-mp="36qheutf7tw0o">
          <span className="whitespace-nowrap" data-id="element-141" data-mp="3ueim7z0nr6ei">音樂備課寶™</span> 是一套獨立的教學資源，並非教育局的官方產品。
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-142" data-mp="3991alritibr">
          © 2026 <span className="whitespace-nowrap" data-id="element-143" data-mp="3lem0a55nkln5">音樂備課寶™</span>。版權所有。
        </p>
      </div>
    </footer>;
}